var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScanMe1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M172.3,220.5c0-5.7-2-10.3-6.1-13.8c-4-3.5-11.1-6.7-21.3-9.8c-17.7-5.1-31-11.1-40.1-18.1 s-13.6-16.6-13.6-28.7s5.2-22.1,15.6-29.8c10.4-7.7,23.6-11.6,39.7-11.6c16.3,0,29.6,4.3,39.9,13c10.3,8.7,15.2,19.3,14.9,32.1 l-0.2,0.6h-28.8c0-6.9-2.3-12.4-6.9-16.7c-4.6-4.2-11-6.4-19.3-6.4c-8,0-14.1,1.8-18.5,5.3c-4.3,3.5-6.5,8.1-6.5,13.6 c0,5,2.3,9.2,7,12.4c4.7,3.2,12.7,6.6,24.1,10.2c16.4,4.6,28.8,10.6,37.2,18s12.6,17.3,12.6,29.5c0,12.7-5,22.7-15,30.1 c-10,7.3-23.3,11-39.7,11c-16.2,0-30.3-4.2-42.3-12.5c-12-8.3-17.9-20-17.5-35l0.2-0.6h29c0,8.8,2.7,15.3,8.1,19.4 c5.4,4.1,12.9,6.2,22.6,6.2c8.1,0,14.3-1.7,18.6-5C170.2,230.6,172.3,226.1,172.3,220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M336.7,208.7l0.2,0.6c0.3,16-4.6,28.6-14.6,38c-10,9.4-23.9,14.1-41.7,14.1c-17.9,0-32.4-5.7-43.5-17.2 s-16.7-26.3-16.7-44.3v-29.5c0-18,5.4-32.8,16.3-44.3s25-17.3,42.4-17.3c18.3,0,32.7,4.7,43,14.1c10.3,9.4,15.4,22.2,15.1,38.5 l-0.2,0.6h-29c0-9.8-2.3-17.3-7-22.5c-4.7-5.2-12-7.8-21.9-7.8c-8.9,0-16,3.6-21.2,10.8c-5.2,7.2-7.8,16.4-7.8,27.7v29.6 c0,11.3,2.8,20.6,8.3,27.9c5.5,7.2,12.9,10.8,22.3,10.8c9.3,0,16.2-2.5,20.6-7.5c4.4-5,6.7-12.4,6.7-22.3H336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M437.7,227.3h-52.1l-10.1,32h-30.1l51.1-148.4H427l50.9,148.4h-30.1L437.7,227.3z M392.9,203.9h37.4 L412,145.6h-0.6L392.9,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M611.7,259.3H582l-59.9-101.4l-0.6,0.1v101.3h-29.8V110.9h29.8l59.9,101.3l0.6-0.1V110.9h29.7V259.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M135.3,314.8l88.1,224.6h1.1l88.1-224.6h47.8v276.5h-37.4V481.9l3.8-112.4l-0.9-0.2l-89.6,222h-24.9 l-89.2-221.4l-0.9,0.2l3.6,111.8v109.4H87.5V314.8H135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M593.1,463.1H466.5v98.7h146v29.4H429.1V314.8h181.3v29.4H466.5v89.4h126.6V463.1z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScanMe1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scan-me-1.964471d75f13420d07eb1bfba2b6c168.svg";